/* eslint-disable max-classes-per-file */
import { MainTableFilterModel } from 'src/app/shared/models/main-table-filter.model';

export class LoadUserActivities {
  static readonly type = '[User Activities] Load User Activities';
  constructor(
    public userId: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class LoadMyUserActivities {
  static readonly type = '[User Activities] Load My User Activities';
  constructor(
    public userId: string,
    public filter?: MainTableFilterModel
  ) {}
}

export class ClearUserActivities {
  static readonly type = '[User Activities] Clear User Activities';
}
